import React from "react"
import IconButton from "@material-ui/core/IconButton"
import {
  EditIcon,
  DeleteIcon,
  SaveIcon,
  CancelIcon,
  VisibilityIcon,
} from "@iconsGallery"
import { Tooltip } from "@material-ui/core"
function IconMenu(props) {
  const {
    isDisableViewIcon = false,
    isDisableSaveButton = false,
    actionEdit = true,
    actionDelete = true,
    isInlineDeleteAllowed = true,
    deleteTooltip,
    editTooltip,
  } = props || {}
  return (
    <div>
      {props.data.inEdit ? (
        <>
          <IconButton
            color="primary"
            aria-label="Save"
            component="span"
            onClick={(...e) => !props.data.saveBTNdisabled && props.save(e)}
            style={
              props.data.saveBTNdisabled
                ? {
                    color: "rgba(0, 0, 0, 0.5)",
                    cursor: "not-allowed",
                  }
                : {}
            }
          >
            <SaveIcon />
          </IconButton>
          <IconButton
            color="primary"
            aria-label="Cancel changes"
            component="span"
            onClick={props.cancel}
          >
            <CancelIcon />
          </IconButton>
          {/* {!props.data.inDeleteIcon || !isInlineDeleteAllowed ? null : */}
          {!props.data.inDeleteIcon ? null : (
            <IconButton
              color="primary"
              aria-label="Delete"
              component="span"
              onClick={props.delete}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </>
      ) : (
        <>
          {isDisableViewIcon === false && (
            <IconButton
              color="primary"
              aria-label="Visiblity"
              component="span"
              onClick={props.view}
            >
              <VisibilityIcon style={{ color: "#1565C0" }} />
            </IconButton>
          )}
          {/* {actionEdit && (
            <IconButton
              color="primary"
              aria-label="Edit"
              component="span"
              onClick={props.in_edit}
              disabled={!props.isInlineEditAllowed || props?.data?.isDefault}
            >
              <EditIcon />
            </IconButton>
          )} */}
          {actionEdit ? (
            !props.isInlineEditAllowed || props?.data?.isDefault ? (
              <Tooltip title={editTooltip} placement="top">
                <span>
                  <IconButton
                    color="primary"
                    aria-label="Edit"
                    component="span"
                    onClick={props.in_edit}
                    disabled={
                      !props.isInlineEditAllowed || props?.data?.isDefault
                    }
                  >
                    <EditIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="Edit" placement="top">
                <IconButton
                  color="primary"
                  aria-label="Edit"
                  component="span"
                  onClick={props.in_edit}
                  disabled={
                    !props.isInlineEditAllowed || props?.data?.isDefault
                  }
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )
          ) : null}
          {actionDelete ? (
            !props.isInlineEditAllowed || props?.data?.isDefault ? (
              <Tooltip title={deleteTooltip} placement="top">
                <span>
                  <IconButton
                    color="primary"
                    aria-label="Delete"
                    component="span"
                    onClick={props.delete}
                    disabled={true}
                  >
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="delete" placement="top">
                <IconButton
                  color="primary"
                  aria-label="Delete"
                  component="span"
                  onClick={props.delete}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )
          ) : null}
        </>
      )}
    </div>
  )
}

export default IconMenu
